// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ce2f3f6d","152":"3014a1d9","350":"1d2b0c19","357":"3bb0136c","444":"097adf32","640":"98b37910","733":"b359498b","813":"ca53d7ea","821":"44d0fefa","914":"fdb25ffc","961":"3bd28c89","991":"b33aa058"}[chunkId] + ".chunk.js";
};